import { render } from "./staff.vue?vue&type=template&id=a57307b6&scoped=true"
import script from "./staff.vue?vue&type=script&lang=js"
export * from "./staff.vue?vue&type=script&lang=js"

import "./staff.vue?vue&type=style&index=0&id=a57307b6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a57307b6"

export default script